<template>
<div>
  <div class="mt-2">
    <transition name="fade">
    <v-card flat v-if="series.length > 0 && !load">
      <v-card-title>
        Desempenho individual
      </v-card-title>
      <apexchart type="bar" :options="chartOptions" :series="series"></apexchart>
    </v-card>
    </transition>
    <transition name="fade">
    <v-card flat v-if="load">
      <v-card flat disabled>
        <v-card-title>
          Desempenho individual
        </v-card-title>
      </v-card>
      <v-skeleton-loader class="mx-auto" type="list-item-three-line" tile="tile"></v-skeleton-loader>
      <v-skeleton-loader class="mx-auto" type="list-item-three-line" tile="tile"></v-skeleton-loader>
    </v-card>
    </transition>
  </div>

  <v-alert v-show="isMsg" type="error">
    Nenhum dado escontrado
  </v-alert>
</div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import service from './../services/userservice'
import { EventBus } from './../main'

export default {
  name: 'desempenho-individual',
  props: {
    mParams: Object
  },
  data () {
    return {
      menu: false,
      height: '',
      load: false,
      chartReg: {},
      erroDate: '',
      cores: ['#33b2df', '#546E7A', '#d4526e', '#13d8aa', '#A5978B', '#2b908f', '#f9a3a4', '#90ee7e',
        '#f48024', '#69d2e7'
      ],
      dados: '',
      isMsg: false,
      osLiberadas: 0,
      series: [],
      chartOptions: {
        chart: {
          id: 'myChart',
          type: 'bar',
          height: 350
        },
        plotOptions: {
          bar: {
            distributed: true,
            horizontal: true
          }
        },
        colors: [],
        dataLabels: {
          enabled: false
        },
        xaxis: {
          categories: []
        }
      }
    }
  },
  watch: {
    mParams (val) {
      this.carregarRanking(this.mParams)
    },
    series (val) {
      var tam = this.series.length()
      if (tam < 10) {
        this.height = 360
      } else {
        this.height = ''
      }
    }
  },
  components: {
    apexchart: VueApexCharts
  },
  methods: {
    limparDados () {
      this.graficos = []
      this.series = []
    },
    carregarRanking (params) {
      EventBus.$emit('loadStop', 1)
      this.load = true
      service.ranking(params).then(r => {
        if (r.status === 200) {
          this.chartOptions = {
            chart: {
              id: 'myChart',
              type: 'bar',
              height: 350
            },
            plotOptions: {
              bar: {
                distributed: true,
                horizontal: true
              }
            },
            colors: [],
            dataLabels: {
              enabled: false
            },
            xaxis: {
              categories: []
            }
          }
          let data = []
          let categories = []
          let list = r.data
          this.isUnidade = true
          list.sort(function (a, b) {
            if (a.QtdLaudosManuais > b.QtdLaudosManuais) {
              return -1
            }
            if (a.QtdLaudosManuais < b.QtdLaudosManuais) {
              return 1
            }
            // a must be equal to b
            return 0
          })
          this.chartOptions.xaxis.categories = []
          for (let i = 0; i < list.length; i++) {
            data.splice(i, 1, list[i].QtdLaudosManuais)
            categories.splice(i, 1, list[i].Responsavel)
          }
          this.chartOptions.xaxis.categories = categories
          // console.log(data)
          this.series.splice(0, 1, {
            name: 'Exames liberados',
            data: data
          })
          for (let i = 0; i < 6; i++) {
            this.chartOptions.colors.push(this.cores[i])
          }
          // eslint-disable-next-line no-undef
          ApexCharts.addXaxisAnnotation('myChart', {
            xaxis: {
              categories: categories
            }
          }, true)
        } else if (r.status === 203) {
          this.isMsg = true
        }
      }).finally(() => {
        EventBus.$emit('loadStop', -1)
      })
    },
    loadStop (is) {
      this.load = is
    }
  },
  mounted () {
    EventBus.$on('load', this.loadStop)
    EventBus.$on('limpar-dados', this.limparDados)
  }
}
</script>
